import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { faFacebookF, faInstagram, faTiktok, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faBars, faChevronDown, faXmark } from "@fortawesome/free-solid-svg-icons";
import { getDomain } from "../helpers";

class Header extends React.Component {
    state = {
        activeLangue: false,
        activeMenu: false,
        activeMenuTel: false,
        reduceRs: false,
        nameLink: ''
    }

    componentDidMount() {
        let queryString = window.location.href;
        let params = queryString.split("/");
        let nameLink = params[3];
        
        this.setState({
            nameLink: nameLink
        })
        setInterval(() => {
            let queryString = window.location.href;
            let params = queryString.split("/");
            let nameLink = params[3];
            
            this.setState({
                nameLink: nameLink
            })  
        }, 5000);

        if (window.innerWidth < window.innerHeight) {
            this.displayRs();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.activeMenu != this.props.activeMenu &&
            this.state.activeMenu != this.props.activeMenu
        ) {
            this.setState({
                activeMenu: this.props.activeMenu,
            })
        }

        if (
            prevProps.activeMenu != this.props.activeMenu &&
            this.state.activeMenuTel != this.props.activeMenu
        ) {
            this.setState({
                activeMenuTel: this.props.activeMenu,
            })
        }

        if (prevState.activeMenu != this.state.activeMenu) {
            this.props.handleMenu(this.state.activeMenu);
        }

        if (prevState.activeMenuTel != this.state.activeMenuTel) {
            this.props.handleMenu(this.state.activeMenuTel);
        }
    }

    toggleLangue() {
        this.setState({activeLangue: !this.state.activeLangue});
    }

    toggleMenu(isOrdi) {
        if (isOrdi) {
            this.setState({activeMenu: !this.state.activeMenu});
        } else {
            this.setState({activeMenuTel: !this.state.activeMenuTel});
        }
    }

    displayRs() {
        window.addEventListener('scroll', (el) => {
            if (window.scrollY == 0) {
                this.setState({reduceRs: false});
                this.props.handleReduceHdr(false);
            } else {
                this.setState({reduceRs: true});
                this.props.handleReduceHdr(true);
            }
        })
    }

    render() {
        return <header className={`hdr ${this.state.reduceRs && "hdr--reduce"} dispAdmin`} id="hdr">
            {/** Réseaux sociaux **/}
            <div className={`hdr__rsx ${this.state.reduceRs && "hdr__rsx--reduce"}`} id="reseaux">
                <a
                    title={`Rejoignez-nous sur notre Instagram - ${this.props.idtt.name}`}
                    aria-label={`Rejoignez-nous sur notre Instagram - ${this.props.idtt.name}`}
                    className="hdr__rs"
                    href="https://www.instagram.com/discovride/#"
                    target="_blank"
                >
                    <FontAwesomeIcon icon={faInstagram} />
                </a>    
                <a
                    title={`Rejoignez-nous sur notre Facebook - ${this.props.idtt.name}`}
                    aria-label={`Rejoignez-nous sur notre Facebook - ${this.props.idtt.name}`}
                    className="hdr__rs"
                    href="https://www.facebook.com/people/DiscovRide/100089340957296/"
                    target="_blank"
                >
                    <FontAwesomeIcon icon={faFacebookF} />
                </a>
                <a 
                    title={`Rejoignez-nous sur notre Youtube - ${this.props.idtt.name}`}
                    aria-label={`Rejoignez-nous sur notre Youtube - ${this.props.idtt.name}`}
                    className="hdr__rs"
                    href="https://www.youtube.com/@discovride"
                    target="_blank"
                >
                    <FontAwesomeIcon icon={faYoutube} />
                </a>
                <a
                    title={`Rejoignez-nous sur notre Tiktok - ${this.props.idtt.name}`}
                    aria-label={`Rejoignez-nous sur notre Tiktok - ${this.props.idtt.name}`}
                    className="hdr__rs"
                    href="https://www.tiktok.com/@discoveride?lang=fr"
                    target="_blank"
                >
                    <FontAwesomeIcon icon={faTiktok} />
                </a>
            </div>

            {/** Logo **/}
            <Link
                title={`Page d'accueil de ${this.props.idtt.name}`}
                aria-label={`Page d'accueil de ${this.props.idtt.name}`}
                className="hdr__logo"
                to={`/`}
            >
                <img
                    src={`${getDomain()}image/logo/${this.props.idtt.logo}`}
                    alt={this.props.idtt.name}
                    className="hdr__logoimg"
                />
            </Link>

            {/** Langue et menu **/}
            <div className={`hdr__lgmenu ${this.state.activeMenuTel && "hdr__lgmenu--active"}`} id="menutel">
                {/** Langue **/}
                <div className="hdr__lgs">
                    <button className={`hdr__lgs__res hdr__lgs__res--btn ${this.state.activeLangue && "hdr__lgs__res--btn--active"}`} onClick={() => this.toggleLangue()} id="btn-langue">
                        <img src="https://static.parastorage.com/services/linguist-flags/1.969.0/assets/flags/round/FRA.png" className="hdr__lgs__drap" alt="Français" />
                        <span className="hdr__lgs__respays">Français</span>
                        <span className={`hdr__lgs__resfleche ${this.state.activeLangue && "hdr__lgs__resfleche--active"}`}>
                            <FontAwesomeIcon icon={faChevronDown} />
                        </span>
                    </button>
                    <div className={`hdr__lgs__list ${this.state.activeLangue && "hdr__lgs__list--active"}`} id="list-langue">
                        {/**
                        <div className="hdr__lgs__res">
                            <img src="https://static.parastorage.com/services/linguist-flags/1.969.0/assets/flags/round/DEU.png" className="hdr__lgs__drap" alt="Deutsch" />
                            <span className="hdr__lgs__respays">Deutsch</span>
                        </div>
                        <div className="hdr__lgs__res">
                            <img src="https://static.parastorage.com/services/linguist-flags/1.969.0/assets/flags/round/GBR.png" className="hdr__lgs__drap" alt="English" />
                            <span className="hdr__lgs__respays">Deutsch</span>
                        </div>
                        **/}
                    </div>
                </div>
                {/** Bouton menu ordi **/}
                <button
                    title="Accéder au menu du site"
                    aria-label="Accéder au menu du site"
                    className="hdr__btnmenu"
                    id="btn-menu-ordi"
                    onClick={() => this.toggleMenu(true)}
                >
                    MENU
                </button>
                {/** Menu **/}
                <nav className={`hdr__menu ${this.state.activeMenu && "hdr__menu--active"}`} id="menu">
                    <Link
                        title={`Accueil - ${this.props.idtt.name}`}
                        aria-label={`Accueil - ${this.props.idtt.name}`}
                        to="/"
                        className={`hdr__menulink ${this.state.nameLink == "" && "hdr__menulink--active"}`}
                    >
                        Accueil
                    </Link>
                    <Link
                        title={`Actualités - ${this.props.idtt.name}`}
                        aria-label={`Actualités - ${this.props.idtt.name}`}
                        to="/actualites"
                        className={`hdr__menulink ${(this.state.nameLink == "actualites" || this.state.nameLink == "article") && "hdr__menulink--active"}`}
                    >
                        Actualités
                    </Link>
                    <Link
                        title={`Galerie - ${this.props.idtt.name}`}
                        aria-label={`Galerie - ${this.props.idtt.name}`}
                        to="/#galerie"
                        className={`hdr__menulink ${this.state.nameLink == "#galerie" && "hdr__menulink--active"}`}
                    >
                        Galerie
                    </Link>
                    <Link
                        title={`Temps d'attente - ${this.props.idtt.name}`}
                        aria-label={`Temps d'attente - ${this.props.idtt.name}`}
                        to="/temps-attente"
                        className={`hdr__menulink ${(this.state.nameLink == "temps-attente" || this.state.nameLink == "temps-d-attente-historique") && "hdr__menulink--active"}`}
                    >
                        Temps d'attente
                    </Link>
                    <Link
                        title={`Boutique - ${this.props.idtt.name}`}
                        aria-label={`Boutique - ${this.props.idtt.name}`}
                        to="/boutique"
                        className={`hdr__menulink ${this.state.nameLink == "boutique" && "hdr__menulink--active"}`}
                    >
                        Boutique
                    </Link>
                    <Link
                        title={`A propos de ${this.props.idtt.name}`}
                        aria-label={`A propos de ${this.props.idtt.name}`}
                        to="/#a-propos"
                        className={`hdr__menulink ${this.state.nameLink == "#a-propos" && "hdr__menulink--active"}`}
                    >
                        A propos de nous
                    </Link>
                    {
                        (localStorage.getItem('userId') == undefined ||
                        localStorage.getItem('userId') == "null") ?
                            <Link
                                title={`Je me connecte`}
                                aria-label={`Je me connecte`}
                                to="/connexion"
                                className={`hdr__menulink ${this.state.nameLink == "connexion" && "hdr__menulink--active"}`}
                            >
                                Connexion
                            </Link> :
                            <Link
                                title={`Accéder à mon profil`}
                                aria-label={`Accéder à mon profil`}
                                to="/profil"
                                className={`hdr__menulink ${this.state.nameLink == "profil" && "hdr__menulink--active"}`}
                            >
                                Profil
                            </Link>
                    }
                    {
                        (localStorage.getItem('userRole') == ["ROLE_SUPER_ADMIN"] ||
                        localStorage.getItem('userRole') == ["ROLE_ADMIN"]) &&
                        <Link
                            title={`Accéder au Back Office`}
                            aria-label={`Accéder au Back Office`}
                            to="/admin/actus"
                            className="hdr__menulink"
                        >
                            Admin
                        </Link>
                    }
                </nav>
                {/** Bouton close tel **/}
                <button
                    title="Fermer le menu"
                    aria-label="Fermer le menu"
                    className="hdr__btnclose"
                    id="btn-close-menu"
                    onClick={() => this.toggleMenu(false)}
                >
                    <FontAwesomeIcon icon={faXmark} />
                </button>
            </div>

            {/** Bouton menu tel **/}
            <button
                title="Ouvrir le menu"
                aria-label="Ouvrir le menu"
                className="hdr__btnopen"
                id="btn-menu-tel"
                onClick={() => this.toggleMenu(false)}
            >
                <FontAwesomeIcon icon={faBars} />
            </button>
        </header>
    }
}

export default Header;

{/** todo : ajouter les réseaux sociaux de dispo pour discordie **/}